import { NavLink } from 'react-router-dom';

const NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: DashboardIcon },
  { to: '/nav-pack', label: 'NAV Pack', icon: DocIcon },
  { to: '/accounting', label: 'Accounting', icon: BookIcon },
  { to: '/portfolio', label: 'Portfolio', icon: BriefcaseIcon },
  { to: '/investor', label: 'Investor', icon: UserIcon },
  { to: '/performance', label: 'Performance', icon: GaugeIcon },
  { to: '/gain-loss', label: 'Gain/Loss', icon: ChartIcon },
];

export default function Sidebar({ open = false, onNavigate }) {
  return (
    <aside className={`sidebar${open ? ' open' : ''}`}>
      <div className="brand">
        <img src="/logo.png" alt="Blue Aster Capital" className="brand-logo" />
        <div className="brand-tag">Internal MIS</div>
      </div>
      <nav className="nav">
        {NAV.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            onClick={onNavigate}
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          >
            <span className="nav-icon"><Icon /></span>
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-foot">© {new Date().getFullYear()} Blue Aster Capital</div>
    </aside>
  );
}

/* --- Inline SVG icons (stroke inherits currentColor) --- */
function Svg({ children }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
  );
}
function DashboardIcon() { return <Svg><rect x="3" y="3" width="7" height="9" /><rect x="14" y="3" width="7" height="5" /><rect x="14" y="12" width="7" height="9" /><rect x="3" y="16" width="7" height="5" /></Svg>; }
function DocIcon() { return <Svg><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><path d="M8 13h8M8 17h8" /></Svg>; }
function BookIcon() { return <Svg><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></Svg>; }
function BriefcaseIcon() { return <Svg><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></Svg>; }
function UserIcon() { return <Svg><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></Svg>; }
function GaugeIcon() { return <Svg><path d="M12 15l3.5-3.5" /><path d="M3 12a9 9 0 1 1 18 0" /><circle cx="12" cy="15" r="1" /></Svg>; }
function ChartIcon() { return <Svg><path d="M3 3v18h18" /><path d="M7 14l3-3 3 3 4-5" /></Svg>; }
